import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextManager, RecommenderService } from '@urbannex/product-multi-recommender';
import { RecommendationStateService } from '@urbannex/product-multi-recommender';
//import { CategoryInput, CategoryRecommendation, ChatMessage, FeatureInput, ImageRecommendationInput, RecommendationInput, RecommendationState } from '@urbannex/product-multi-recommender';
import { CategoryInput, CategoryRecommendation, ChatMessage, FeatureInput, ImageRecommendationInput, RecommendationInput, RecommendationState } from '@urbannex/product-multi-recommender';
import { Subscription, catchError, finalize, throwError } from 'rxjs';
import { InputPanelComponent } from '../input-panel/input-panel.component';
import { NbButtonModule, NbLayoutModule } from '@nebular/theme';
import { AssistantConfig } from '@urbannex/view-containers';

@Component({
  selector: 'ubs-recommendation-chat',
  standalone: true,
  imports: [CommonModule,InputPanelComponent,NbLayoutModule,NbButtonModule],
  templateUrl: './recommendation-chat.component.html',
  providers: [
    RecommenderService, 
    RecommendationStateService
    ],
  /* template: `
      <div class="chat-container poes">
        <div class="nb-card-header">
          Header Goese Here
        </div>
        <div class="message-flow">
          <div *ngFor="let message of messages" class="message" [ngClass]="message.type">
            <div class="message-content">
              <ng-container [ngSwitch]="message.type">
                <!-- Category Recommendations -->
                <div *ngSwitchCase="'category'" class="category-message">
                  <h4>Suggested Categories:</h4>
                  <div *ngFor="let category of message.content" class="category-item">
                    <button (click)="selectCategory(category)">
                      {{ category.fullPath }}
                    </button>
                    <span class="confidence">({{ category.confidence }}%)</span>
                  </div>
                </div>

                <!-- Feature Recommendations -->
                <div *ngSwitchCase="'feature'" class="feature-message">
                  <h4>Recommended Features:</h4>
                  <ul>
                    <li *ngFor="let feature of message.content">
                      <strong>{{ feature.name }}</strong> - {{ feature.description }}
                      <span class="feature-type">{{ feature.type }}</span>
                    </li>
                  </ul>
                </div>

                <!-- Generated Descriptions -->
                <div *ngSwitchCase="'description'" class="description-message">
                  <h4>{{ message.subType === 'short' ? 'Short Description' : 'Detailed Description' }}</h4>
                  <p>{{ message.content }}</p>
                  <div class="metadata" *ngIf="message.metadata">
                    <span>Words: {{ message.metadata.wordCount }}</span>
                    <span>Keywords: {{ message.metadata.keywords?.join(', ') }}</span>
                  </div>
                </div>

                <!-- Error Messages -->
                <div *ngSwitchCase="'error'" class="error-message">
                  <p>{{ message.content }}</p>
                  <button class="retry-btn" (click)="retry()">Try Again</button>
                </div>
              </ng-container>
            </div>
          </div>

          <div *ngIf="state.loading" class="loading-indicator">
            <div class="spinner"></div>
            <span>Generating recommendations...</span>
          </div>
        </div>

        <div class="input-section">
          <ubs-input-panel
            [currentStep]="state.currentStep"
            [isLoading]="state.loading"
            (textSubmit)="handleTextInput($event)"
            (imageSubmit)="handleImageUpload($event)"
            (categoryDescriptionSubmit)="handleTextInput($event)">
          </ubs-input-panel>
        </div>
      </div>
  `, */
  styleUrls: ['./recommendation-chat.component.scss']
})
export class RecommendationChatComponent implements OnInit, OnChanges, OnDestroy {
  @Input() assistantConfig:AssistantConfig;
  state!: RecommendationState;
  private stateSubscription!: Subscription;
  name:string;                              //The name of the assistant
  assistantDescription:string;             //The description for the assistant
  path:string;             //The description for the assistant


  //state = this.stateService.state;
  messages: ChatMessage[] = [];
  //private stateSubscription: any;

  constructor(
    private stateService: RecommendationStateService,
    private recommender: RecommenderService,
    private context: ContextManager
  ) {}

  ngOnInit() {
    console.log("ngOnInit method called");
    this.stateSubscription = this.stateService.state$.subscribe(state => {
      this.state = state;
      this.updateMessages(state);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['assistantConfig']) {
      if(this.assistantConfig != undefined){
        console.log(this.assistantConfig);
        this.name = this.assistantConfig?.name;
        this.assistantDescription = this.assistantConfig?.capabilities[0].description
        if(this.assistantConfig?.path != undefined){
          this.path = this.assistantConfig?.path;
        }
      }
      
      
      //this.context.setAssistantConfig(this.assistantConfig);
    }
  }

  private updateMessages(state: RecommendationState) {
    this.messages = [];
    
    // Add categories if present
    if (state.categories.length > 0) {
      this.messages.push({
        type: 'category',
        content: state.categories,
        timestamp: new Date()
      });
    }

    // Add features if present
    if (state.features.length > 0) {
      this.messages.push({
        type: 'feature',
        content: state.features,
        timestamp: new Date()
      });
    }

    // Add descriptions if present
    if (state.descriptions.short || state.descriptions.long) {
      this.messages.push({
        type: 'description',
        content: state.descriptions.long || state.descriptions.short,
        timestamp: new Date()
      });
    }
  }
  // Update handleTextInput method
  
handleTextInput(query: string) {
  console.log("handleTextInput method called", query);
  console.log("text received")
  this.stateService.setLoading(true);
  
  const baseInput: RecommendationInput = {
    userInput: query,
    taxonomyVersion: 'latest' // Add your taxonomy version
  };

  switch (this.state.currentStep) {
    case 'category':
      console.log(query);
      const categoryInput: CategoryInput = {
        ...baseInput,
        productType: query,
        marketRegion: 'US' // Default or user-selected
      };

      this.recommender.getCategoryRecommendation(categoryInput)
        .subscribe({
          next: result => {
            // Properly typed category mapping
            console.log(result);
            const categories = result.recommendations.map(c => ({
              id: c.id,
              fullPath: c.fullPath,
              hierarchy: c.hierarchy,
              confidence: c.confidence,
              validationStatus: c.validationStatus,
              taxonomyVersion: c.taxonomyVersion,
              reason:c.reason,
              hierarchyLevel:c.hierarchyLevel
            }));
            this.stateService.updateCategories(categories);
          },
          error: err => this.handleError(err),
          complete: () => this.stateService.setLoading(false)
        });
      break;

    case 'features':
      if (!this.state.selectedCategory) {
        this.stateService.setError('No category selected');
        return;
      }

      const featureInput: FeatureInput = {
        ...baseInput,
        category: this.state.selectedCategory,
        requiredFeatures: [] // Add any required features
      };

      this.recommender.getFeatureRecommendation(featureInput)
        .subscribe({
          next: result => {
            this.stateService.updateFeatures(
              result.recommendations.map(f => f.name)
            );
          },
          error: err => this.stateService.setError(err.message),
          complete: () => this.stateService.setLoading(false)
        });
      break;
  }
}

  /* handleTextInput(query: string) {
    this.stateService.setLoading(true);
    
    switch (this.state.currentStep) {
      case 'category':
        this.recommender.getCategoryRecommendations(query)
          .subscribe({
            next: categories => this.stateService.updateCategories(categories),
            error: err => this.stateService.setError(err.message),
            complete: () => this.stateService.setLoading(false)
          });
        break;

      case 'features':
        this.recommender.getFeatureRecommendations(query)
          .subscribe({
            next: features => this.stateService.updateFeatures(features),
            error: err => this.stateService.setError(err.message),
            complete: () => this.stateService.setLoading(false)
          });
        break;
    }
  } */
 // Update handleImageUpload method
async handleImageUpload(file: File) {
  this.stateService.setLoading(true);
  
  try {
    const base64 = await this.convertToBase64(file);
    const imageInput: ImageRecommendationInput = {
      userInput: 'Analyze product image',
      imageBase64: base64,
      maxWidth: 1024, // Add appropriate values
      maxHeight: 768
    };

    const result = await this.recommender.analyzeImage(imageInput).toPromise();
    
    if (result?.recommendations?.length) {
      this.stateService.updateImageAnalysis(result.recommendations[0]);
    }
  } catch (error) {
    this.stateService.setError(error.message);
  } finally {
    this.stateService.setLoading(false);
  }
}

  /* async handleImageUpload(file: File) {
    this.stateService.setLoading(true);
    try {
      const analysis = await this.recommender.analyzeImage(file);
      this.stateService.updateImageAnalysis(analysis);
    } catch (error) {
      this.stateService.setError(error.message);
    } finally {
      this.stateService.setLoading(false);
    }
  } */

  selectCategory(category: string) {
    this.stateService.selectCategory(category);
  }

  retry() {
    this.stateService.setError(null);
    // Add custom retry logic based on current step
  }
  // Add to component class
private convertToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

  /* private convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  } */

  private handleError(error: any) {
    this.stateService.setError(error.message || 'An unexpected error occurred');
    return throwError(() => error);
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }
}

// Interfaces

